import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AddressDetailPage } from './address-detail.page';

const routes: Routes = [
  {
    path: '',
    component: AddressDetailPage
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AddressDetailPageRoutingModule {}
